<template>
    <footer id="display_ctrl_footer" 
        class="display-ctrl"
    >
        <v-btn 
            class="display-ctrl__btn" 
            @click="$emit('trigger-display-function')" 
            text 
        >
            <span class="display-ctrl__text">{{$t('__map_obs.show_pic_data')}}</span>
        </v-btn>
    </footer>
</template>

<script>
    export default {
        name: 'DisplayCtrlFooter',

        props: {
            text: {
                type: String,
                default () {
                    return ''
                }
            },
        },    
    }
</script>

<style lang="scss" scoped>
    @import '../../../../css/mixin';

    .display-ctrl {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 48px;
        text-align: center;
        background: var(--base-gray-darken);

        &__btn {
            width: 10rem;
            height: 2rem;
            background-color: var(--aqua-active);
            border-radius: 2rem;
        }

        &__text {
            font-size: 1rem;
            font-weight: 900;
            letter-spacing: .6px;
            line-height: 1.5;
            color: var(--base-dark-blue);
        }
    }

    @include device-hoverable {   
        .display-ctrl__btn:hover {
            background-color: var(--base-dark-blue);

            .display-ctrl__text {
                color: var(--aqua-active);
            }
        }
    }
</style>
